import type { Option } from '@/modules/common/types/option.type.ts';
import type { CounterpartyMasterForm } from '@/modules/counterparty/counterparty-master/types/master-form.ts';
import type { CounterpartyManagerSections } from '@/modules/counterparty/counterparty-master/types/manager-form.ts';

export type ManagerFormPatch = {
  manager: Option<number> | null;
  segment: Option<number> | null;
  region: Option<number> | null;
  city: Option<string> | null;
  sections: CounterpartyManagerSections;
};

export function applyManagerForm(current: CounterpartyMasterForm, patch: ManagerFormPatch): CounterpartyMasterForm {
  const off = (section: keyof CounterpartyManagerSections) => current.sections[section] && !patch.sections[section];

  return {
    ...current,
    manager: patch.manager,
    segment: patch.segment,
    region: patch.region,
    city: patch.city,
    sections: patch.sections,
    addresses: off('addresses') ? [] : current.addresses,
    contacts: off('contacts') ? [] : current.contacts,
    bankDetails: off('bankDetails') ? [] : current.bankDetails,
    isSubordinated: off('subordination') ? false : current.isSubordinated,
    parents: off('subordination') ? [] : current.parents,
    comment: off('comment') ? '' : current.comment,
  };
}
